import { RadioGroup } from "../../radio";
import { ToggleButton } from "../../button";
import { isNil, useEventCallback } from "../../shared";
import { jsx as _jsx } from "react/jsx-runtime";
export function ButtonPresets({
  onSelectionChange,
  selectedIndex,
  values
}) {
  const handleSelectPreset = useEventCallback((event, value) => {
    onSelectionChange(event, parseInt(value));
  });
  return /*#__PURE__*/_jsx(RadioGroup, {
    "aria-label": "Date presets",
    className: "o-ui-date-input-button-presets",
    gap: 2,
    onChange: handleSelectPreset,
    orientation: "horizontal",
    value: !isNil(selectedIndex) ? selectedIndex.toString() : null,
    children: values.map((x, index) => /*#__PURE__*/_jsx(ToggleButton // eslint-disable-next-line react/no-array-index-key
    , {
      size: "sm",
      value: index.toString(),
      variant: "secondary",
      children: x
    }, index))
  });
}